module.exports = __webpack_public_path__ + "assets/884d75d7caac3656e3ac34e4aea513af.png";